import { FC, ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { COUNT_MONTH_MPLUS, isShowingBonus } from 'shared/constants'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  moneyPayNow?: string
  creditMoneyEachMonth?: string
  countPassengers?: number
  eachPassengerPayInfo?: string

  showCashbackInfo?: () => void
  showPayInfo?: () => void
}

interface DetailInfoProps {
  left: ReactNode
  right: ReactNode
}

const DetailInfo: FC<DetailInfoProps> = ({ left, right }) => {
  return (
    <div className={s.line}>
      {left}

      {right}
    </div>
  )
}

const InfoIcon = () => {
  return (
    <AppIcon
      height={14}
      width={14}
      id={AllIcons.INFO}
      className={s.iconInfo}
    />
  )
}

export const MplusDetail: FC<Props> = ({
  moneyPayNow,
  countPassengers,
  eachPassengerPayInfo,
  creditMoneyEachMonth,

  showPayInfo,
  showCashbackInfo,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <DetailInfo
        left={<p className={clsx('bold-16', s.title)}>{t('mplus.pay_now')}</p>}
        right={
          <p
            className={clsx('bold-16', s.title)}
          >{`${priceShow(moneyPayNow || '0')} \u20c0`}</p>
        }
      />

      <DetailInfo
        left={
          <p className={clsx('medium-14', s.info)}>
            {t('price_for_passengers', { count: countPassengers })}
          </p>
        }
        right={
          <p
            onClick={showPayInfo}
            className={clsx('medium-14', s.info, s.iconItem)}
          >
            {t('mplus.price_each_month', {
              count: COUNT_MONTH_MPLUS,
              money: priceShow(eachPassengerPayInfo),
            })}
            <InfoIcon />
          </p>
        }
      />

      <DetailInfo
        left={
          <p className={clsx('regular-14', s.info)}>
            {t('mplus.from_next_month')}
          </p>
        }
        right={
          <p className={clsx('regular-14', s.info)}>
            {`${priceShow(creditMoneyEachMonth)} `} &#8384;
          </p>
        }
      />

      {isShowingBonus && (
        <DetailInfo
          left={
            <p
              onClick={showCashbackInfo}
              className={clsx('bold-14', s.bonus, s.iconItem)}
            >
              {t('mplus.cashback_bonus')} <InfoIcon />
            </p>
          }
          right={
            <p className={clsx('regular-14', s.title)}>{t('not_allowed')}</p>
          }
        />
      )}
    </div>
  )
}
